export const state = {
    loader: false,
    activityLogs:[]
  }
  